
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/white-background",
      function () {
        return require("private-next-pages/white-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/white-background"])
      });
    }
  